var $eea63e10a4dec777$exports = {};
(()=>{
    const states = {
        true: "remove",
        false: "add"
    };
    const titles = document.querySelectorAll(".faq .title");
    const handleClick = ({ currentTarget: { parentElement: parentElement } })=>{
        const isOpen = parentElement.classList.contains("open");
        titles.forEach((title)=>title.parentElement.classList.remove("open"));
        parentElement.classList[states[isOpen]]("open");
    };
    titles.forEach((title)=>title.onclick = handleClick);
    let periodicity = "year";
    let currency = "\u20AC";
    const periodicitiesMap = {
        Annually: "year",
        Monthly: "month"
    };
    const currenciesMap = {
        USD: "$",
        Euro: "\u20AC"
    };
    const prices = {
        "\u20AC": {
            year: [
                180,
                405
            ],
            month: [
                220,
                490
            ]
        },
        "$": {
            year: [
                200,
                450
            ],
            month: [
                240,
                540
            ]
        }
    };
    const periodicityNodes = document.getElementById("periodicity").querySelectorAll(".switcher-item");
    const currencyNodes = document.getElementById("currency").querySelectorAll(".switcher-item");
    const handleChangePeriodicity = ({ currentTarget: currentTarget })=>{
        periodicity = periodicitiesMap[currentTarget.dataset.item];
        renderPrices();
    };
    const handleChangeCurrencie = ({ currentTarget: currentTarget })=>{
        currency = currenciesMap[currentTarget.dataset.item];
        renderPrices();
    };
    periodicityNodes.forEach((item)=>item.onmousedown = handleChangePeriodicity);
    currencyNodes.forEach((item)=>item.onmousedown = handleChangeCurrencie);
    const renderPrices = ()=>{
        document.querySelectorAll(".fixPrice").forEach((item, i)=>{
            item.querySelector("h2").innerHTML = `${currency}${prices[currency][periodicity][i]}/ month`;
        });
    };
    renderPrices();
    let injected = true;
    const withSticky = [
        ...document.querySelectorAll(".withSticky")
    ].reduce((acc, item)=>{
        const childs = [
            ...item.children
        ];
        return [
            ...acc,
            {
                parent: item,
                childs: childs
            }
        ];
    }, []);
    const ejectChilds = ()=>{
        withSticky.forEach(({ parent: parent, childs: childs })=>{
            [
                ...childs
            ].reverse().forEach((item)=>parent.after(item));
            parent.innerHTML = "";
        });
    };
    const injectChilds = ()=>{
        withSticky.forEach(({ parent: parent, childs: childs })=>{
            [
                ...childs
            ].reverse().forEach((item)=>{
                item.remove();
                parent.prepend(item);
            });
        });
    };
    const onChangeSticky = ()=>{
        if (window.innerWidth <= 975 && injected) {
            injected = false;
            ejectChilds();
        } else if (window.innerWidth > 975 && !injected) {
            injected = true;
            injectChilds();
        }
    };
    window.onresize = onChangeSticky;
    onChangeSticky();
})();


//# sourceMappingURL=price.1eeee545.js.map
